<template>
  <div class="register">
    <register-card/>
  </div>
</template>
<script>
import RegisterCard from '../../components/login/RegisterCard.vue'
export default {
    data() {
        return {

        }
    },
    methods() {

    },
    components: {
        RegisterCard
    }
}
</script>